import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import {lastValueFrom, Observable} from "rxjs";
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OperationIndicatorsService {
  constructor(private http: HttpClient, private authService: AuthService){}

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
    }

  sendFunds(request: OperationIndicatorsService) : Observable<any>
  {
    return this.http.post<any>(this.url('/tef'), request);
  }

  searchAccount(accountId: string): Promise<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("accountId", accountId);
    return lastValueFrom(this.http.get<any>(this.url('/tef/GetTef'),{params: queryParams}))
  }

}

